import axios from 'axios'
import {
  Message,
  Loading
} from 'element-ui'
import {
  getUUId
} from '@/utils/uuid'
import {
  getToken
} from '@/utils/auth'
import {
  encryptDes,
  decryptDes
} from '@/utils/des'

// create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'localhost' ? 'http://localhost:1601/fjtecPortalWeb' : '/fjtecPortalWeb', // api 的 base_url
  timeout: 60000 // request timeout
})

let loading // 定义loading变量

function startLoading() { // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    fullscreen: true,
    spinner: 'el-icon-loading',
    background: 'rgba(255, 255, 255, 0)',
    text: '正在加载......',
    customClass: 'loadingClass'
  })
}

function endLoading() { // 使用Element loading-close 方法
  loading.close()
}
// 那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
// 声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
// 调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['X-Token'] = getToken()
    //   // config.header['token'] = getToken()
    // }
    if (config.data && config.data.header) {
      config.data.header.site = process.env.VUE_APP_SITE || 'main'
      config.data.header.noVeriToken = true
      config.data.header.requestSource = 'PORTAL'
      config.data.header.token = getToken()
      config.data.header.requestSeq = getUUId(32, 16)
      // config.data.header.operatorId = store.getters.user.userId
    }
    if (config.data.header && !config.data.header.noShowLoading) {
      showFullScreenLoading()
    }
    if (process.env.VUE_APP_PARAM_1) {
      config.data = {
        content: encryptDes(config.data, process.env.VUE_APP_PARAM_1)
      }
    }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()
    if (process.env.VUE_APP_PARAM_1) {
      response.data = JSON.parse(decryptDes(response.data, process.env.VUE_APP_PARAM_1))
    }
    if (Object.prototype.toString.call(response.data) === '[object Blob]') {
      return response
    } else {
      if (response.data !== '') {
        if (response.data && response.data.header && response.data.header.resultCode === 0) {
          return response.data.content
        } else {
          Message({
            message: response.data.header.resultMsg,
            type: 'error',
            duration: 5 * 1000
          })
          return Promise.reject(response.data.header.resultMsg)
        }
      } else {
        // Message({
        //   message: '服务请求异常，请稍后再试',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        return Promise.reject('服务请求异常，请稍后再试')
      }
    }
    // return response
  },
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    tryHideFullScreenLoading()
    if (response !== undefined) {
      if (response.response) {
        // const res = response.response.data
        let res = null
        if (process.env.VUE_APP_PARAM_1) {
          res = JSON.parse(decryptDes(response.response.data, process.env.VUE_APP_PARAM_1))
        } else {
          res = response.response.data
        }
        if (res.code !== 20000) {
          Message({
            message: res.message,
            type: 'error',
            duration: 5 * 1000
          })
          return Promise.reject('error')
        } else {
          return response.data
        }
      } else {
        // Message({
        //   message: '连接服务器异常，请稍后再试',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
      }
      return Promise.reject('error')
    }
  },
  error => {
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service

const diyRequest = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30000 // request timeout
})

export {
  diyRequest
}